import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
// import store from '@state/store'
let serverUrl = getSecret('SERVER_MASTER_URL')
let serverFormsUrl = getSecret('SERVER_FORMS_URL')


export const state = {

}

export const actions = {
    getReportByIndexVars(context, payload) {
        return axios.post(`${serverFormsUrl}/api/reports/answers/indexed/`, payload)
        .then((response) => {
            return response.data
        })
    },
    getReportByFilterVars(context, payload) {
        return axios.post(`${serverFormsUrl}/api/reports/answers/filtered/`, 
            payload.data, payload.type
        )
    },
    getReportLog(context, query) {
        return axios.get(query)
    },
}